import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib/i18N';
import React from 'react';
import SharedConstants from '../../../common/constants/SharedConstants';

/**
 * Select Options Component
 */
export const SelectOptions = props => {
  const { tabIndex, ariaLable, className, options, onChange, testid = '', selectedValue, ...rest } = props;
  /**
   * On Key Press Handler
   * @param {*} evt - Event Object
   */
  const onKeyPressHandler = evt => {
    // Char Code - Space and Enter
    const { SPACE, ENTER } = SharedConstants.KEY_CHAR_CODE;
    if (onChange && (evt.charCode === SPACE || evt.charCode === ENTER)) {
      onChange();
    }
  };

  const getOptions = item => {
    const sel = selectedValue === item ? { selected: 'selected' } : '';
    return (
      <option key={item} value={item} defaultValue={selectedValue === item} {...sel}>
        {translateWithI18Next(item)}
      </option>
    );
  };

  return (
    <select
      className={className}
      tabIndex={tabIndex}
      aria-label={ariaLable}
      onChange={onChange}
      onKeyPress={onKeyPressHandler}
      data-testid={testid}
      defaultValue={selectedValue}
      {...rest}
    >
      {options?.map(item => {
        return getOptions(item);
      })}
    </select>
  );
};

export default SelectOptions;
